
import React from 'react';
import { LayoutDashboard, History, ShieldAlert, BarChart3, UserCircle, Wallet } from 'lucide-react';

export const COLORS = {
  bg: '#0b0e11',
  surface: '#1e2329',
  surfaceHover: '#2b3139',
  primary: '#00ff66',
  yellow: '#fbbf24',
  green: '#00ff66',
  greenGlow: 'rgba(0, 255, 102, 0.2)',
  red: '#f6465d',
  blue: '#4788ff',
  textMain: '#ffffff',
  textSecondary: '#eaecef',
  textMuted: '#848e9c',
  border: '#474d57',
};

export const MENU_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', icon: <LayoutDashboard size={20} /> },
  { id: 'history', label: 'Histórico', icon: <History size={20} /> },
  { id: 'stats', label: 'Estatísticas', icon: <BarChart3 size={20} /> },
  { id: 'profile', label: 'Meu Perfil', icon: <UserCircle size={20} /> },
  { id: 'finance', label: 'Financeiro', icon: <Wallet size={20} />, adminOnly: true },
  { id: 'admin', label: 'Painel Admin', icon: <ShieldAlert size={20} />, adminOnly: true },
];
